"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LegalPartnerForBusinessCertainty() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}